export default[
    {
        show(row,extra){
            return row.shbj==='1'||row.shbj == "4"||row.shbj == "9" || row.shbj == "6"|| row.shbj == "5"|| row.shbj == "7"
        },
        tag:'my-btn',
        type:'detail',
        text:'详情',
        click(row,extra){
            this.goto({
                path: '/bidding/projectflow/dingbiao/zbhxrgs/detail',
                query: {
                    id: row.gscode,
                    procode:this.getQuery('procode')
                }
            });
            
        }
    },{
        show(row,extra){
            return row.shbj==="0"||row.shbj==="3"
        },
        tag:'my-btn',
        type:'del',
        text:'删除',
        click(row,extra){
            this.$post(`${this.getGetters('mngUrl')}/DingBiao/ZbHxrGs/del.json`,{
                oper:'del',
                id:row.gscode
            }, (data, res) => {
                ShowMsg('删除成功','success')
                this.$emit('reload')
            });
            
        }
    },{
        show(row,extra){
            return row.shbj==="0"||row.shbj==="3"
        },
        tag:'my-btn',
        type:'edit',
        text:'修改',
        click(row,extra){
            var url = ''
            if(row.gstypecode==='2'){
                // 修改变更公告
                url = '/bidding/projectflow/dingbiao/zbhxrgs/bggs'
            }else{
                url = '/bidding/projectflow/dingbiao/zbhxrgs/form'
            }
            this.goto({
                path: url,
                query: {
                    id: row.gscode,
                    procode:this.getQuery('procode'),
                    isXt:this.getQuery('isXt'),
                }
            });
            
        }
    },{
        show(row,extra){
            return (row.shbj==='1'||row.shbj == "9" || row.shbj == "6"|| row.shbj == "5"|| row.shbj == "7")&&row.shbj == "9"&&row.gstypecode==='1'
        },
        tag:'el-button',
        type:'text',
        icon: 'el-icon-s-promotion',
        text:'发布变更公示',
        click(row,extra){
            this.goto({
                path: '/bidding/projectflow/dingbiao/zbhxrgs/bggs',
                query: {
                    procode: this.getQuery('procode'),
                    bdcode: row.bdcode,
                    isXt:this.getQuery('isXt'),
                }
            });
            
        }
    },
]